<template>
  <div :class="{ disabled: disabled, isPcModal: isPcModal }" class="inputItemWrapper">
    <select
      v-if="!isSelectListIsObject"
      v-model="handleSelectValue"
      class="inputItem"
      :class="{ hasError: hasError, disabled: disabled }"
      :disabled="disabled"
      autocomplete="off"
    >
      <option disabled class="placeholderOption" value="">{{ placeholderValue }}</option>
      <option v-for="selectItem of selectList" :key="selectItem" :value="selectItem">
        {{ selectItem }}
      </option>
    </select>
    <select
      v-else
      v-model="handleSelectValue"
      class="inputItem"
      :class="{ hasError: hasError, disabled: disabled }"
      :disabled="disabled"
      autocomplete="off"
    >
      <option :disabled="!optional" :class="{ placeholderOption: !optional }" value="">{{ placeholderValue }}</option>
      <option v-for="selectItem of selectList" :key="selectItem.value" :value="selectItem.value">
        {{ selectItem.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectBox',
  model: {
    prop: 'selectValue',
    event: 'change',
  },
  props: {
    placeholderValue: {
      type: String,
      required: false,
      default: '',
    },
    selectValue: {
      type: String,
      required: false,
      default: '',
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectList: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 資料請求確認画面PC、 予約確認画面PCの時のみtrue
     * 両画面の変更フォームをモーダル内に表示する際にスタイル調整するため。
     */
    isPcModal: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    optional: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      validationError: false,
      value: '',
    };
  },
  computed: {
    isSelectListIsObject() {
      if (!this.selectList.length) return false;
      return typeof this.selectList[0] === 'object';
    },
    handleSelectValue: {
      get() {
        if (this.model === undefined) {
          if (this.selectValue) return this.selectValue;
          return '';
        }
        return this.model;
      },
      set(value) {
        this.value = value;
        this.$emit('change', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

// select自体には擬似要素がつかないのでWrapperする
.inputItemWrapper {
  height: 48px;
  width: 100%;
  position: relative;

  .inputItem {
    &.disabled {
      color: $color-text-spot-caption;
      background-color: $color-background-primary-third;
      opacity: 1;
    }

    &::-ms-expand {
      // IE対応: セレクトボックスの矢印の除去
      display: none;
    }

    .placeholderOption {
      display: none;
    }

    background-color: $color-background-primary-third-light;
    border: $border-sapuri-white-light;
    border-radius: 6px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    font-size: $text-size-paragraph2;
    color: $color-text-primary;
    padding: 12px;
    appearance: none;

    &.hasError,
    &.hasError:focus {
      border-radius: 6px;
      border: $border-alert;
    }

    &:focus {
      outline: none;
      border: solid 1px $color-action-primary;
    }
  }

  &::after {
    position: absolute;
    content: '';
    right: 12px;
    top: 20px;
    border-top: 8px solid $color-text-secondry;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
  }

  &.disabled::after {
    border: none;
  }

  &.isPcModal {
    width: 396px;
    margin-left: 32px;
  }
}
</style>
